@if (dataSource.length > 0) {
  <table
    mat-table
    [dataSource]="tableSource"
    class="mat-elevation-z8"
    multiTemplateDataRows
  >
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
        <td mat-cell *matCellDef="let element">
          {{ element[column.key] }}
        </td>
      </ng-container>
    }
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions"></th>
      <td mat-cell *matCellDef="let element">
        <div
          (click)="
            expandedElement = expandedElement === element ? null : element;
            $event.stopPropagation()
          "
        >
          @if (expandedElement === element) {
            <mat-icon>keyboard_arrow_up</mat-icon>
          } @else {
            <mat-icon>keyboard_arrow_down</mat-icon>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="displayedColumns.length"
        style="padding: 0px"
      >
        <div
          class="table-detail"
          [@detailExpand]="
            element == expandedElement ? 'expanded' : 'collapsed'
          "
        >
          <div class="sub-table">
            <div class="subt-header">
              <span class="st-id">ID</span>
              <span class="st-func">Função</span>
              <span class="st-hab">Status</span>
              <span class="st-action"></span>
            </div>
            @for (permission of element.permissions; track permission.id) {
              <div class="subt-item">
                <span class="st-id">{{ permission.endpointId }}</span>
                <span class="st-func">{{ permission.nomeFuncao }}</span>
                <span class="st-hab">{{
                  permission.permitido == 'S' ? 'Permitido' : 'Não Permitido'
                }}</span>
                <span class="st-action">
                  @if (
                    permission.nomeFuncao.toLowerCase() != 'listar' &&
                    permission.nomeFuncao.toLowerCase() != 'pesquisar'
                  ) {
                    <button
                      [ngClass]="
                        permission.permitido == 'S'
                          ? 'btn-disable'
                          : 'btn-enable'
                      "
                      (click)="updatePermission(permission)"
                    >
                      {{ permission.permitido == 'S' ? 'Remover' : 'Conceder' }}
                      permissão
                    </button>
                  }
                </span>
              </div>
            }
          </div>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      class="style-row"
      *matRowDef="let row; columns: displayedColumns"
      [class.example-expanded-row]="expandedElement == row"
      (click)="expandedElement = expandedElement == row ? null : row"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="example-detail-row"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}
